import React from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import Routes from "Configs/routes";
import { Paginator, PaginatorElem } from "ComponentsUI/Pagination";
import { generateUrl } from "Services/withDefaultParams";

// const LIMIT = 20;

const PaginationContainerFC = (props) => {
	let {
		ApplicationModel: { windowSizeModel },
		match,
		pagination,
		limit,
	} = props;

	let tagCode = match.params.tagCode;
	let path = generateUrl(Routes.RatesTags.route, {
		regionUrl: match.params.regionUrl,
		tagCode: tagCode,
	});
	let pageTotal = Math.ceil((pagination ? pagination.items_total : 0) / limit);
	let page = 1;
	if (match.params.page) {
		page = match.params.page;
	}

	return (
		<Paginator
			key={23}
			itemsTotal={pagination ? pagination.items_total : 0}
			itemsPerPage={limit}
			pageCurrent={page}
			pageTotal={pageTotal}
			windowSizes={windowSizeModel.windowSizes}
			urlDefault={path}
			wrapperItem={<PaginatorElem />}
			location={props.location}
			datatest="tariffs.tags"
		/>
	);
};

export default withRouter(inject("ApplicationModel")(observer(PaginationContainerFC)));
